//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TermoAceiteLogin',
  components: {
  },
  props: {
    termos: Array,
    title: String,
  },
  data() {
    return {
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      termo: {},
      continuar: true,
      index: 0,
      termoAceito: false,
      timeout: true,
      sombraToolbar: false,
    };
  },
  computed: {
  },
  methods: {
    logout() {
      const auth = this.$auth || window.auth;
      auth.logout();
    },
    proximo() {
      if (this.continuar) {
        this.index = this.index + 1;
        this.termo = this.termos[this.index];
        if (this.index >= (this.termos.length - 1)) {
          this.continuar = false;
        }
        this.termoAceito = false;
        this.timeoutAceito();
      } else {
        this.finalizar();
      }
    },
    timeoutAceito() {
      this.timeout = true;
      window.setTimeout(() => {
        this.timeout = false;
      }, 5000);
    },
    onScroll(i) {
      if (i.currentTarget.scrollY) {
        this.sombraToolbar = true;
      } else {
        this.sombraToolbar = false;
      }
    },
    finalizar() {
      this.termoAceiteResources.aceitarTermos(this.termos)
      .then(() => {
        this.$emit('ACEITO');
      }).catch((err) => {
        this.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
  },
  mounted() {
    if (this.termos.length) {
      this.termo = this.termos[this.index];
      if (this.termos.length < 2) {
        this.continuar = false;
      }
      this.timeoutAceito();
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/termo-aceite/TermoAceiteLogin.vue?vue&type=script&lang=js&